module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_goodcen.07e0809414fe5d67dadfd621419ccf12.png";